import { useRef, useState } from 'react'
import { SubmitHandler, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import axios from 'axios'
import * as yup from 'yup'

const useEmailSignup = (listId: string, onSuccess = () => {}) => {
  const recaptchaRef = useRef(null)
  const [serverError, setServerError] = useState<string>('')
  const [loading, setIsLoading] = useState<boolean>(false)

  const {
    handleSubmit,
    register,
    reset,
    formState: { errors },
  } = useForm<IFormInputs>({
    defaultValues: { email: '' },
    resolver: yupResolver(schema),
  })

  const onSubmit: SubmitHandler<IFormInputs> = async ({ email }) => {
    try {
      setIsLoading(true)
      const token = await (recaptchaRef?.current as any).executeAsync()
      if (!token)
        return setServerError('Please verify that you are not a robot.')

      const isVerified = await verifyCaptcha(token)
      if (!isVerified) return setServerError('Invalid input response')

      const response = await fetch('/api/klaviyoSignUp', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, listId }),
      })
      if (!response.ok)
        return setServerError(
          (await response.json())?.error || 'An error occurred.'
        )

      setServerError('')
      onSuccess()
      reset({ email: '' })
    } catch (error) {
      setServerError('Failed to subscribe. Please try again later.')
    } finally {
      ;(recaptchaRef as any).current.reset()
      setIsLoading(false)
    }
  }

  return {
    state: { serverError, errors, loading },
    handlers: { handleSubmit, register, onSubmit },
    refs: { recaptchaRef },
  }
}

const verifyCaptcha = async (token: string) => {
  try {
    const response = await axios.post('/api/verifyRecaptcha', { token })
    return response.data.success
  } catch (error) {
    console.error('Error verifying captcha:', error)
    return false
  }
}

interface IFormInputs {
  email: string
}

const schema = yup
  .object()
  .shape({
    email: yup
      .string()
      .email('Please enter a valid email address')
      .required('Email is required'),
  })
  .required()

export default useEmailSignup
